import _debounce from 'lodash.debounce'

export default {
  namespaced: true,
  state: {
    items: [],
    loading: false,
    service: {
      path: 'adminmaps',
      mainField: 'denumire'
    },
    msgTemplates: {
      resource: 'harti client',
      main: 'denumire'
    }
  },
  getters: {
    items: state => state.items,
    loading: state => state.loading
  },
  mutations: {
    clearState (state) {
      state.items = []
    },
    setItems (state, payload) {
      state.items = payload
    },
    setLoading (state, payload) {
      if (!payload) {
        setTimeout(() => {
          state.loading = payload
        }, 500)
      } else {
        state.loading = payload
      }
    }
  },
  actions: {
    setEventWatchers ({ commit, dispatch, rootState }) {
      rootState.services.adminmaps.events.forEach(event => {
        rootState.services.adminmaps.on(event, data => {
          commit('setLoading', true)
          // dispatch('fetchTabs')
          dispatch('fetchItems')
        })
      })
      rootState.services.adminmaps.on('batchDeleteSuccess', data => {
        dispatch('fetchItems')
      })
    },
    fetchItems: _debounce(({ state, commit, rootState, dispatch }) => {
      commit('setLoading', true)
      // USAGE: .find({query: {$complexFacet: true, $skip: 0, $limit: 10, tip_apl: 'Judet', $regex: 'bla'}})
      let query = { $complexFacet: true, $paginate: false }

      rootState.feathers.service(state.service.path).find({ query }).then(result => {
        // dispatch('saveMessage', {
        //   user: rootState.auth.user._id,
        //   text: `Citire "${state.msgTemplates.resource}" reusita. Total: ${result.length || 0}`,
        //   timestamp: (new Date()).toLocaleDateString('ro-RO', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric' }),
        //   type: 'info'
        // }, { root: true })

        commit('setItems', result)
      }).catch(err => {
        dispatch('saveMessage', {
          user: rootState.auth.user._id,
          text: `Eroare la interogare "${state.msgTemplates.resource}"... Detalii: ${err.message || err.error.message}`,
          timestamp: (new Date()).toLocaleDateString('ro-RO', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric' }),
          type: 'error'
        }, { root: true })
        commit('setLoading', false)
      }).finally(() => {
        commit('setLoading', false)
      })
    }, 1000)
  }
}
